export default __webpack_public_path__ + "static/media/EM0430.34I-22656_-15125_0.19b928b8.jpg";